
<div class="overview w_255" [class.box1]="box == '1'">
    <div class="overview-data">
       <div class="progress-container" *ngIf="box == '2' && (vacant ||  occupied)">
            <div class="progress-vacant" matTooltip="{{'Vacant'| translate}}: {{overviewData?.vacant_percentage}}" matTooltipPosition="above" [ngStyle]="{ 'width.%': vacant }"><ng-container *ngIf="(vacant > occupied)">{{vacant | number: '1.0-0'}}%</ng-container></div>
            <div class="progress-occupied" matTooltip="{{'Occupied'| translate}}: {{overviewData?.occupied_percentage}}" matTooltipPosition="above" [ngStyle]="{ 'width.%': occupied }"><ng-container *ngIf="(occupied > vacant)">{{occupied | number: '1.0-0'}}%</ng-container></div>
        </div>
        <h2>{{card_title | translate}} <ng-container *ngIf="symble">({{symble}})</ng-container></h2>
        <div class="untill" *ngIf="overviewData?.untillDate">
            <span>{{"reports.asOf" | translate}}</span>
            <span class="directionLtr"> {{ overviewData?.untillDate }}</span>
            <span *ngIf="overviewData?.standalone_properties">, {{overviewData.standalone_properties | number: '1.0-0'}} {{'reports.Standalone' | translate}}</span>
        </div>
        <ng-container *ngIf="!overviewData?.untillDate">
            <ng-container *ngIf="isShowtransactionDate; else showTTMmessage">
                <div class="until ttm-date" *ngIf="overviewData?.min_date && overviewData?.max_date">
                    <span>{{"from" | translate}}</span>
                    <span class="ttm-date-span">{{getFormattedDate(overviewData.min_date)}}</span>
                    <span>{{"reports.to" | translate}}</span>
                    <span class="ttm-date-span">{{getFormattedDate(overviewData.max_date)}}</span>
                </div>
            </ng-container>
            <ng-template #showTTMmessage>
                <span>{{"reports.ttm" | translate}}</span>
            </ng-template>
        </ng-container>
       
        <div class="rates" *ngIf="box == '2'">
            <div class="rate-block">
                <h5>{{'reports.land' | translate}}</h5>
                <div class="value">{{ overviewData?.total_land_area | number: '1.0-0' }}</div>
                <div class="properties-count">{{ overviewData?.no_of_parcels | number: '1.0-0' }} {{'Parcel' | translate}}</div>
            </div>
            <div class="rate-block">
                <h5>{{'reports.builtUp'| translate}}</h5>
                <div class="value">{{overviewData?.built_up_area | number: '1.0-0'}}</div>
                <div class="properties-count"> {{overviewData?.builtup_properties  | number: '1.0-0'}} {{'reports.projectsProperties' | translate}}</div>
            </div>
        </div>

        <div class="rates" *ngIf="box == '3'">
            <div class="rate-block">
                <h5>{{'reports.land' | translate}}</h5>
                <div class="value">{{overviewData?.land_transaction_rate ? (overviewData.land_transaction_rate | number: '1.0-0'):'-'}}</div>
            </div>
            <div class="rate-block">
                <h5>{{'reports.builtUp'| translate}}</h5>
                <div class="value">{{overviewData?.builtup_transaction_rate ? (overviewData.builtup_transaction_rate | number: '1.0-0'):'-' }}</div>
            </div>
        </div>
    </div>
    <ng-container  *ngIf="box == '1'">
        <div class="value value-padding">{{overviewData?.total_properties | number: '1.0-0'}}</div>
        <div class="bottom">
            <div class="projects">
                <div class="count">{{overviewData?.project_count | number: '1.0-0'}}</div>
                <div class="label">{{'reports.project' | translate}}</div>
            </div>
            <div class="arrow">
                <svg width="11" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7071 14.2071C13.0976 13.8166 13.0976 13.1834 12.7071 12.7929L6.34315 6.42893C5.95262 6.03841 5.31946 6.03841 4.92893 6.42893C4.53841 6.81946 4.53841 7.45262 4.92893 7.84315L10.5858 13.5L4.92893 19.1569C4.53841 19.5474 4.53841 20.1805 4.92893 20.5711C5.31946 20.9616 5.95262 20.9616 6.34315 20.5711L12.7071 14.2071ZM0 13.5V14.5H12V13.5V12.5H0V13.5Z" fill="black"/>
                </svg>
            </div>
            <div class="properties">
                <div class="count">{{(overviewData?.project_properties || 0) | number: '1.0-0'}}</div>
                <div class="label">{{'reports.project_properties' | translate}}</div>
            </div>
        </div>
    </ng-container>
</div>